import styled from "styled-components";
const MotorWrapper = styled.div`
.full-width-div {
  max-width: 100%;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
}
.ar {
  font-family: "tawuniya" !important;
}
.left-sec {
  background: #ffffff;
  color: #000;
  border-bottom-right-radius: 60px;
  box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
  height: 100vh;
  @media only screen and (max-width: 1200px) {
    height:auto !important;
  }
}
.component {
  margin-bottom: 0 !important;
}
.container-wrapper {
  margin: auto;
}
.header-mob {
  display: none;
}
.container-wrapper-mob {
  margin-bottom: 40px;
}
.full-width-div-mob {
  max-width: 100%;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
}
.left-sec-mob {
  background: #ffffff;
  color: #000;
  background: none;
  color: #000;
  border-bottom-right-radius: 0px;
  box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
  height: 100%;
  margin-bottom: 30px;
}



// /* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .container-wrapper {
    max-width: 700px;
  }
}


/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .container-wrapper {
    max-width: 900px;
  }
}

@media only screen and (min-width: 1700px) {
  .container-wrapper {
    max-width: 1160px;
  }
}

.full-width-div {
  max-width: 100%;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
}

.left-sec {
  background: #ffffff;
  color: #000;
  border-bottom-right-radius: 60px;
  box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
  height: 100vh;
}
.component {
  margin-bottom: 110px;
}
.container-wrapper {
  margin: auto;
}
.header-mob {
  display: none;
}
.container-wrapper-mob {
  margin-bottom: 40px;
}
.p-tabview-nav-link:not(.p-disabled):focus {
  box-shadow: none !important;
}
.full-width-div-mob {
  // background: #F2F3F5 !important;
  max-width: 100%;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
  .left-sec-mob {
    margin-bottom: 0  !important;
    filter: drop-shadow(0px 4px 10px rgba(9, 30, 66, 0.06));
    border-radius: 0px 0px 10px 10px;
  }
  .right-nav {
    padding-top: 30px !important;
  }
}
.left-sec-mob {
  background: #ffffff;
  color: #000;
  background: none;
  color: #000;
  border-bottom-right-radius: 0px;
  box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
  height: 100%;
  margin-bottom: 30px;
  z-index: 2;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .container-wrapper-mob {
    max-width: 700px;
  }
}

// /* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .container-wrapper {
    max-width: 700px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .container-wrapper {
    max-width: 900px;
  }
}

@media only screen and (min-width: 1700px) {
  .container-wrapper {
    max-width: 1160px;
  }
}
@media only screen and (max-width: 576px){
  .container-wrapper-mob {
    margin-bottom: 80px;
    .motor-person {
      margin-top: 0 !important;
    }
  }
  .personal-details-head {
    .rborder, .last{
      padding: 0;
      margin-bottom: 1rem;
    }
  }
  .right-nav, .p-tabview-panels, .p-tabview-nav-link, .visa-form {
    background: #F2F3F5;
  }
  .container-wrapper-mob {
    min-height: 80vh;
    margin-bottom: 80px;
    .motor-person {
      margin-top: 0 !important;
    }
    .visa-form {
        margin-top: 10px;
     }
    .visit-visa-mob   {
      margin-top: 0 !important;
      .p-tabview-ink-bar {
        display:none;
      }
      .p-tabview-panels {
        padding: 0.5rem;
      }
      .p-tabview-nav {
        background: #F2F3F5;
      }
      .p-tabview-nav-link {
        border-radius: 100px;
        padding: 0.5rem 0.625rem;
        .p-tabview-title {
          font-size: 12px;
        }
      }
      .header 
      {
        p {
          display:none;
        }
        h5 {
          font-size:0.9rem;
        }
      }
      form {
        padding: 0;
        margin-top: 1rem !important;
        .p-inputtext {
            font-size: 0.8rem;
        }
      }
      .checkbox-wrapper {
        label {
          text-align: justify;
          font-size: 0.8rem;
        }
      }
      
    }
    .kyc_mob {
      margin-top: 0 !important;
      .card {
        padding: 0 !important;
        background: #F2F3F5;
      }
      .Dec-det {
        margin: 0;
        padding:15px;
      }
      .conditions-section {
        padding: 0 15px 15px;
      }
      .p-accordion-content {
        padding: 12px !important;
      }
      .Heading-dec {
        font-size: 1rem;
      }
      .Subheading {
        font-size:  0.9rem;
      }
      label, .Subheading-oth {
        font-size: 0.9rem;
      }
      .Heading-other {
        font-size: 1rem;
      }
      .p-accordion .p-accordion-header .p-accordion-header-link {
        padding: 0 10px !important;
      }
    }

    .visa-detail {
      margin-top: 0 !important;
      .p-accordion .p-accordion-header .p-accordion-header-link {
        padding: 10px !important;
      }
      .set-accord{
        margin-bottom: 10px !important;
      }
      .welcome-text {
        padding: 0 15px !important;
        font-size: 0.9rem !important;
      }
      .Icon-Div a {
        font-size: 0.9rem !important;
        display: none;
      }
      .header  {
        h5, p{
          font-size: 0.9rem !important;
        }
      }
      .p-message-wrapper{
        font-size: 0.9rem;
        padding: 1rem 0.5rem;
      }
      .section-header{
          font-size: 0.9rem !important;
      }
      small {
        font-size: 0.8rem !important;
      }
      .p-accordion-content{
        padding: 0 12px !important;
        .personal-details-head {
          padding: 24px 12px 0 12px !important;
          h4 {
            font-size: 0.9rem !important;
          }
          .rborder {
            border-right: none;
          }
        }
      }
      .form_wrapper {
        padding: 1rem !important;
        font-size: 0.9rem !important;
      }
      .switch_wrapper {
        .p-inputswitch {
          margin: 0 10px 0 0;
          min-width:50px;
        }
      }
      .date_range_wrapper > * .date {
        font-size: 0.8rem;
      }
      .section_header{
        font-size: 0.9rem !important;
      }
    }
  }
}

.component-mob{
  padding-bottom: 1rem;
}

.ar{
  font-family: "tawuniya" !important;

  .left-sec {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 60px;
  }
  .welcome-text{
    font-family: "tawuniya" !important;
    span{
      font-family: "tawuniya" !important;
      font-weight: 700;
    }
  }
}
`;

export default MotorWrapper;
